import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance';

import Swal from 'sweetalert2'; // Import SweetAlert2
import withReactContent from 'sweetalert2-react-content'; // Import React components for SweetAlert2
 import { useNavigate, Link } from 'react-router-dom';
import toast from "react-hot-toast";
import LoadingTable from '../../components/LoadingTable';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
//  import { DateRangePicker } from 'react-date-range';
// import 'react-date-range/dist/styles.css'; // main style file
// import 'react-date-range/dist/theme/default.css'; // theme css file

const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components


const AdminAllBilling = () => {
    const [Dateinputs, setDateinputs] = useState({
        startDate: null, // Use null or a default Date object
        endDate: null    // Use null or a default Date object
    });

    const handleStartDateChange = (ranges) => {
        setDateinputs((prevState) => ({
            ...prevState,
            startDate: ranges.selection.startDate,
            endDate: ranges.selection.endDate,
        }));
    };




    const [DateFilter, SetDateFilter] = useState(false);
 

 
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setlimit] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');


    const fetchData = async () => {
        try {

            setLoading(true);

            const startDate = Dateinputs.startDate ? Dateinputs.startDate.toISOString() : '';
            const endDate = Dateinputs.endDate ? Dateinputs.endDate.toISOString() : '';

            const response = await axiosInstance.get(`/admin/all-payments?page=${currentPage}&limit=${limit}&search=${searchTerm}&startDate=${startDate}&endDate=${endDate}`);

            setCurrentPage(response.data.currentPage);
            setTotalPages(response.data.totalPages);
            const data = response.data.data;
            console.log(data)
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
            setData([]);
            setlimit(10);
            setTotalPages(1);
            setCurrentPage(1);
        } finally {
            setLoading(false);
            SetDateFilter(false);
        }

    };



    useEffect(() => {
        if (DateFilter) {
            fetchData(currentPage);
        }
    }, [DateFilter]);

    useEffect(() => {
        fetchData(currentPage);
    }, [currentPage, limit]);


    const handleDateFilter = () => {
        SetDateFilter(true);
        setCurrentPage(1)
    }

    const handleClearFilter = () => {
        SetDateFilter(true);
        setCurrentPage(1);
        setDateinputs((prevState) => ({
            ...prevState,
            startDate: null,
            endDate: null,
        }));
    }

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };


    // Function to handle delete
    const handleDelete = (categoryId) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this data!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true,
            customClass: {
                popup: 'custom-swal-popup', // Add a class to the entire dialog
                confirmButton: 'btn-danger', // Add a class to the confirm button
            },
        }).then((result) => {
            if (result.isConfirmed) {


                axiosInstance.delete(`/admin/delete-zones/${categoryId}`)
                    .then(() => {
                        // Refresh the data or update the state after successful deletion
                        fetchData();
                        toast.success("Deleting Rating success!");
                    })
                    .catch((error) => {
                        console.error('Error deleting data:', error);
                        toast.error("Error deleting data");
                    });
            }
        });
    };


    const handleStatusChange = (StatusId) => async (event) => {
        const newStatus = event.target.value;
        setLoading(true);

        try {
            await axiosInstance.put(`/admin/update-user/${StatusId}`, { status: newStatus });
            setLoading(false);
            fetchData(currentPage);
            toast.success("Status Updated success!");
        } catch (error) {
            console.error('Error updating rating status:', error);
            setLoading(false);
        }
    };



    const inputRef = React.createRef();

    const handleSearchInputChange = (e) => {
        setCurrentPage(1);
        setTotalPages(1)
        setSearchTerm(e.target.value);


    };

    const handleSearch = () => {
        fetchData(currentPage);

    };


    const [WalletLoading, setWalletLoading] = useState(true);



    let initialWalletData = {
        _id: null,
        TotalAmount: 0,
        WalletType: '',
        Amount: null,
        Comment: '',
    };

    const [WalletInputs, setWalletInputs] = useState(initialWalletData);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'Amount' && parseFloat(value) < 0) {
            // You can handle the error, show a message, or prevent further action here
            // For now, let's reset the value to 0
            // You might want to handle this differently based on your UI/UX requirements
            toast.error('Negative numbers not allowed for Amount');
            return;
        } else {
            setWalletInputs((prevData) => ({ ...prevData, [name]: type === 'checkbox' ? checked : value }));

        }

    };



    function formatDate(dateString) {
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(dateString).toLocaleDateString("en-US", options);
    }



    const ExportData = async () => {
        try {
            const response =



                await toast.promise(
                    axiosInstance.get(
                        `/admin/export/alltrans`,
                        { responseType: 'blob' }
                    ),
                    {
                        loading: "Export All Payments...", // Loading message
                        success: "Exporting Successfully!", // Success message
                        error: "Failed To Export All Payments.", // Error message
                    }
                );

            // await axiosInstance.get(`/admin/export/alltrans/`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'allusers_data.csv');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.error('Error exporting data:', error);
            toast.error('Error exporting data:', error);
        }

    };

    return (
        <>

              <Sidebar />
              <main class="content">
                <Navbar />
        
                <div className="py-4">
                 
                     <div className="dashboard-content bg-white px-4 py-3 " style={{ maxWidth: "100vw", }} >



                    <div className="table-responsive py-4" style={{ overflow: "visible" }} >

                        {loading ? (
                            <LoadingTable />
                        ) : (
                            <>




                                <div className="dropdown">


                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        data-bs-auto-close="outside"
                                        aria-expanded="false"
                                    >
                                        <i className="ri-filter-2-fill me-2"></i>   Filter
                                    </button>


                                    {(Dateinputs.startDate && Dateinputs.endDate) &&
                                        <span className='d-inline-block  p-2  border-right'>
                                            <label className='d-inline-block fw-bold'> Start Date
                                            </label> <br />
                                            <div className="d-inline-block badge rounded-pill bg-dark px-2 py-2 " type="button" onClick={handleClearFilter}>
                                                <i className="ri-close-line bg-white p-1 rounded-xl me-1 text-dark"></i>
                                                {formatDate(Dateinputs.startDate.toISOString())}
                                            </div>
                                        </span>}

                                    {(Dateinputs.startDate && Dateinputs.endDate) &&
                                        <span className='d-inline-block  p-2'>
                                            <label className='d-inline-block fw-bold'>End Date
                                            </label> <br />
                                            <div className="d-inline-block badge rounded-pill bg-dark px-2 py-2 " type="button" onClick={handleClearFilter}>
                                                <i className="ri-close-line bg-white p-1 rounded-xl me-1 text-dark"></i>
                                                {formatDate(Dateinputs.endDate.toISOString())}
                                            </div>
                                        </span>}

                                    <div className="dropdown-menu border rounded-md p-4  table-flow overflow-auto " style={{ zIndex: "99" }} >



                                        <b className='d-block fw-bold'> Filters By Date </b>

                                        {/* <DateRangePicker className=" my-3 w-auto "
                                            onChange={handleStartDateChange}
                                            showSelectionPreview={true}
                                            moveRangeOnFirstSelection={false}
                                            ranges={[
                                                {
                                                    startDate: Dateinputs.startDate,
                                                    endDate: Dateinputs.endDate,
                                                    key: 'selection',
                                                },
                                            ]}
                                        /> */}

                                        <div className='d-flex text-right justify-content-between align-items-center'>


                                            {Dateinputs.startDate && Dateinputs.endDate && (<>

                                                <button
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseExample"
                                                    aria-expanded="true"
                                                    aria-controls="collapseExample" onClick={handleClearFilter}
                                                    className=' btn btn-sm btn-danger text-white me-4'>
                                                    <i className="ri-delete-bin-5-fill me-2"></i> Clear
                                                </button>
                                                <button
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseExample"
                                                    aria-expanded="true"
                                                    aria-controls="collapseExample" onClick={handleDateFilter}
                                                    className='ms-auto btn btn-sm btn-secondary bg-dark text-white '>
                                                    <i className="ri-filter-3-fill me-2"></i> Apply
                                                </button>
                                            </>)}
                                        </div>

                                    </div>

                                    <div className='bg-fix' />

                                </div>






                                <div className="datatable-top d-flex justify-content-between align-items-center">
                                    <div className="datatable-dropdown col">



                                        <label className='d-flex gap-2 align-items-center'>
                                            <select className="form-control w-auto pe-4" value={limit} onChange={(e) => {
                                                setlimit(parseInt(e.target.value, 10));
                                                setCurrentPage(1); // Reset current page to 1 when the limit changes
                                            }} >
                                                <option value={5}>5</option>
                                                <option value={10} >
                                                    10
                                                </option>
                                                <option value={15}>15</option>
                                                <option value={20}>20</option>
                                                <option value={25}>25</option>
                                                <option value={100}>100</option>
                                                <option value={500}>500</option>
                                                <option value={1000}>1000</option>

                                            </select>{" "}

                                            entries per page
                                        </label>




                                    </div>

                                    <header className="header bg-transparent style-2 col-md-4">
                                        <div className="header-content">
                                            <div className="search-area d-flex">

                                                <div className=" input-rounded w-100">
                                                    <input type="search" className="form-control" placeholder="Search..." value={searchTerm}
                                                        onChange={handleSearchInputChange} />
                                                </div>

                                                <button type={'button'} onClick={handleSearch} className="rounded-circle ms-2 back-btn border-0 d-flex justify-content-center align-items-center">
                                                    <i className="ri-search-line h4 m-0"></i>
                                                </button>


                                            </div>
                                        </div>
                                    </header>



                                </div>


                                <div className='overflow-auto table-flow'>

                                    <table className="table table-flush">
                                        <thead>
                                            <tr>
                                                <th>Transaction No.</th>
                                                <th> Date</th>
                                                <th> Amount</th>
                                                <th> Comment</th>
                                                <th> Customer Details</th>
                                                <th>Payment Method</th>



                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((row, index) => (
                                                <tr key={index}>
                                                    <td  className='small'>{row.t_id}</td>
                                                    <td  className='small' >{formatDate(row.createdAt)}</td>

                                                    <td  className='small' >{row.amount}</td>
                                                    {/* <td>{row.type}</td> */}
                                                    <td  className='small' >{row.note}</td>
                                                    <td  className='small' >
                                                        <p  className='small' >Full Name : {row?.userId?.username !== undefined ?
                                                            row?.userId?.username : 'Anonymous User'}
                                                            <br />
                                                            Phone NO. :  {row?.userId?.phone !== undefined ?
                                                                row?.userId?.phone : 'Not Found'}
                                                            <br />
                                                            Current Wallet :  {row?.userId?.wallet !== undefined ?
                                                                row?.userId?.wallet : 'Not Found'}



                                                        </p>
                                                    </td>

                                                    <td  className='small' >
                                                        Wallet
                                                    </td>








                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="datatable-bottom">
                                    <div className="datatable-info">  </div>
                                    <nav className="datatable-pagination ms-auto">
                                        <ul className="pagination justify-content-end">

                                            <li className={`page-item rounded-md ${currentPage === 1 ? 'datatable-hidden' : 'active'} bg-transparent  `}>
                                                <button data-page="1" className="page-link " onClick={handlePreviousPage} disabled={loading || currentPage === 1}
                                                    aria-label="Page 1">‹</button>
                                            </li>
                                            <li>
                                                <div className="datatable-info py-1 px-3">Showing  Page{' '}
                                                    <strong>
                                                        Showing Page  {currentPage} of {totalPages}

                                                    </strong>{' '} </div>
                                            </li>
                                            <li className={`page-item rounded-md ${currentPage === totalPages ? 'datatable-hidden' : 'active'}`}>
                                                <button data-page="2" className="page-link" aria-label="Page 2" onClick={handleNextPage} disabled={loading || currentPage === totalPages}
                                                >  {loading ? 'Loading...' : '›'} </button>
                                            </li>
                                        </ul></nav>
                                </div>



                            </>
                        )}

                    </div>




                </div>


  </div>
  </main>
  
        </>
    )
}

export default AdminAllBilling